import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

import { StickyService } from './sticky.service';


@Component({
  moduleId: module.id,
  selector: 'sticky-element, [stickyElement]',
  template: `
    <div class="sticky-container"
    [class.scrolled]="scrolled"
    #stickyContainer>
      <div class="sticky-element" #stickyElement>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['sticky.component.scss'],
})
export class StickyComponent implements OnInit {

  @Input() name: string = '';
  @Input() order: number;
  public position: number = 0;
  public clientHeight: number = 0;

  // Active fixed element
  public active: boolean = false;

  // Scrolled element
  public scrolled: boolean = false;

  @ViewChild('stickyContainer', {static: true})
  private stickyContainer: ElementRef | void;

  @ViewChild('stickyElement', {static: false})
  private stickyElement: ElementRef | void;

  constructor(
    public elementRef: ElementRef,
    private stickyService: StickyService,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.definePosition();
      this.stickyService.addItem(this);
    });
  }

  public definePosition() {
    if (!this.stickyContainer) {
      return;
    }
    this.clientHeight = this.stickyContainer.nativeElement.clientHeight;
    this.position = this.stickyContainer.nativeElement.offsetTop;
    if (this.scrolled) {
      const index = this.stickyService.stickyList.indexOf(this);
      const next = this.stickyService.stickyList[index + 1];
      const position = next.containerPosition - this.clientHeight;
      this.setTopPosition(position);
    }
  }

  public addClass(className: string): StickyComponent {
    this.elementRef.nativeElement.classList.add(className);
    return this;
  }

  public removeClass(className: string): StickyComponent {
    this.elementRef.nativeElement.classList.remove(className);
    return this;
  }

  public hasClass(className: string) {
    return this.elementRef.nativeElement.classList.contains(className);
  }

  public removeAttr(attr: string): StickyComponent {
    if (this.stickyElement) {
      this.stickyElement.nativeElement.removeAttribute(attr);
    }
    return this;
  }

  public get offsetTop(): number {
    if (this.stickyElement) {
      return this.stickyElement.nativeElement.offsetTop;
    }
  }

  public get containerPosition(): number {
    return this.stickyContainer && this.stickyContainer.nativeElement.offsetTop;
  }

  public setTopPosition(value: number): StickyComponent {
    if (this.stickyElement) {
      this.stickyElement.nativeElement.style.top = `${value}px`;
    }
    return this;
  }


}
